import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { usePlayer } from '../../context/PlayerContext';
import { Mail, Lock, ArrowRight, Check } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PlayerLogin = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = usePlayer();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    if (searchParams.get('registered') === 'true') {
      setShowSuccess(true);
      setTimeout(() => setShowSuccess(false), 5000);
    }
  }, [searchParams]);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    
    try {
      const response = await axios.post(`${API}/player/login`, formData);
      login(response.data);
      navigate('/player/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <section className="page-hero" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center' }}>
        <div className="container" style={{ maxWidth: '480px' }}>
          <div className="network-card" style={{ padding: '48px 32px' }}>
            <div style={{ textAlign: 'center', marginBottom: '32px' }}>
              <h1 className="heading-1" style={{ marginBottom: '8px' }}>Player Login</h1>
              <p className="body-medium" style={{ color: 'var(--text-light)' }}>
                Access your player profile and dashboard
              </p>
            </div>

            {showSuccess && (
              <div style={{
                padding: '12px 16px',
                background: 'rgba(34, 197, 94, 0.2)',
                border: '1px solid #22c55e',
                borderRadius: '8px',
                color: '#22c55e',
                marginBottom: '24px',
                fontSize: '0.875rem',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                <Check size={18} /> Account created successfully! Please sign in.
              </div>
            )}

            {error && (
              <div style={{
                padding: '12px 16px',
                background: 'rgba(220, 38, 38, 0.2)',
                border: '1px solid #dc2626',
                borderRadius: '8px',
                color: '#ef4444',
                marginBottom: '24px',
                fontSize: '0.875rem'
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-group" style={{ marginBottom: '16px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                  <Mail size={16} /> Email
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Enter your email"
                />
              </div>

              <div className="form-group" style={{ marginBottom: '16px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                  <Lock size={16} /> Password
                </label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  placeholder="Enter your password"
                />
              </div>

              <div style={{ textAlign: 'right', marginBottom: '24px' }}>
                <Link to="/player/forgot-password" style={{ color: 'var(--brand-primary)', fontSize: '0.875rem', textDecoration: 'none' }}>
                  Forgot Password?
                </Link>
              </div>

              <button 
                type="submit" 
                className="btn-primary" 
                disabled={loading}
                style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}
              >
                {loading ? 'Signing In...' : 'Sign In'}
                {!loading && <ArrowRight size={20} />}
              </button>
            </form>

            <p style={{ textAlign: 'center', marginTop: '24px', color: 'var(--text-light)' }}>
              Don't have an account?{' '}
              <Link to="/player/register" style={{ color: 'var(--brand-primary)', textDecoration: 'none' }}>
                Create Account
              </Link>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PlayerLogin;
